import styled from 'styled-components';

export const Header = styled.header`
  width: 100vw;
  background: #32404e;
  display: flex;
  align-items: center;
  justify-content: center;

  .containerHeader {
    max-width: 1300px;
    width: 100vw;
    display: flex;
    align-items: center;
    justify-content: space-between;

    @media (max-width: 1256px) {
      justify-content: space-around;
    }
  }

  img {
    height: 27px;
    width: 100px;
  }

  div {
    flex-direction: row;

    button {
      color: #f4f4f4;
      line-height: 50px;
      padding: 0 3px;
      margin: 0 0 0 15px;
      font-weight: 700;
      font-size: 1rem;
    }

    .btn-secondary {
      background-color: transparent;
      border-color: transparent;

      &:hover {
        background-color: transparent;
        border-color: transparent;
      }

      &:focus {
        background-color: transparent;
        border-color: transparent;
      }
    }
  }
`;

export const Main = styled.main`
  .container {
    display: flex;
    justify-content: space-around;
    flex-flow: wrap;
  }

  min-height: 400px;
  display: flex;
  justify-content: center;
  position: relative;

  .Toastify__toast-container--top-left {
    position: absolute;
  }

  .Toastify__toast-container--top-right {
    position: absolute;
  }

  @media (max-width: 768px) {
    .Toastify__toast-container--top-left {
      position: fixed;
    }

    .Toastify__toast-container--top-right {
      position: fixed;
    }
  }

  #firstBox {
    @media (max-width: 768px) {
      display: none;
    }
    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 25px;
      left: 72px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }
    h4 {
      position: absolute;
      top: 50px;
      left: 82px;
      font-size: 43px;
      color: #869cb3;
      font-weight: 1000;
    }

    #participants {
      top: 126px;
      left: 63px;
      font-weight: normal;
      color: #6b8299;
    }
  }

  #firstBoxLow {
    @media (min-width: 768px) {
      display: none;
    }
    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 25px;
      left: 76px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }
    h4 {
      position: absolute;
      top: 51px;
      left: 87px;
      font-size: 43px;
      color: #869cb3;
      font-weight: 1000;
    }
  }

  #secondBox {
    @media (max-width: 768px) {
      display: none;
    }
    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 25px;
      left: 55px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }
    .timer-wrapper {
      position: absolute;
      text-align: center;
      top: 47px;
      min-width: 225px;
      font-size: 36px;
      color: #869cb3;
      font-weight: 1000;
    }

    #PlayerLeft {
      top: 126px;
      left: 70px;
      font-weight: normal;
      color: #62c744;
    }
  }

  #secondBoxLow {
    @media (min-width: 768px) {
      display: none;
    }

    position: relative;
    margin-top: 33px;
    p {
      position: absolute;
      top: 25px;
      left: 55px;
      color: #fff;
      font-size: 12px;
      font-weight: bold;
    }
    .timer-wrapper {
      position: absolute;
      text-align: center;
      top: 44px;
      min-width: 225px;
      font-size: 43px;
      color: #869cb3;
      font-weight: 1000;
    }
  }

  #BountyLogo {
    @media (min-width: 992px) {
      display: none;
    }
    img {
      width: 450px;
      padding-top: 7px;

      @media (max-width: 555px) {
        width: 75vw;
      }
    }
  }

  #spaceOfKill {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 18px;

    @media (max-width: 991px) {
      display: none;
    }

    img {
      width: 450px;
      padding-bottom: 18px;

      @media (max-width: 555px) {
        width: 75vw;
      }
    }

    #Rounds {
      margin-bottom: 7px;
    }

    #Rounds .buttonOfRound1 {
      background-color: #63b2e6;
      height: 34px;
      width: 195px;
      width: 210px;
      border: 0;
      border-radius: 3px 0 0 3px;
      color: #f4f4f4;
      text-align: center;
      font-size: 14px;
      font-weight: 700;
    }

    #Rounds .buttonOfRound2 {
      background-color: #32404e;
      height: 34px;
      width: 195px;
      width: 210px;
      border: 0;
      border-radius: 0 3px 3px 0;
      color: #6b8299;
      text-align: center;
      font-size: 14px;
      font-weight: 700;
    }
  }

  h3 {
    color: #ffcc00;
    font-size: 19px;
    font-weight: 600;
    margin-bottom: 5px;
  }

  p {
    color: #869cb3;
    font-size: 12px;
    font-weight: 700;
  }

  form {
    background-color: #32404e;
    height: 121px;
    width: 420px;
    border-radius: 7px;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    margin-top: 10px;
    padding: 10px;

    #bet {
      background-color: #1a2530;
      height: 34px;
      width: 390px;
      border: 0;
      border-radius: 3px;
      color: #f4f4f4;
      text-align: left;
      padding-left: 10px;
      font-size: 12px;

      ::placeholder {
        text-align: left;
        color: #32404e;
        font-style: italic;
      }
    }

    @media (max-width: 660px) {
      width: 66vw;

      #bet {
        width: 56vw;
      }
    }

    .button {
      background-color: #63b2e6;
      border-color: #63b2e6;
      box-shadow: inset 0 -3px 0 #4897cc;
      width: 128px;
      height: 37px;
      border: 0;
      color: #f4f4f4;
      font-size: 17px;
      font-weight: 700;
      border-radius: 20px;

      :disabled {
        background-color: #379cdf;
        border-color: #2c97dd;
      }

      :hover {
        background-color: #79c2f2;
        border-color: #79c2f2;
      }

      div {
        display: none;
        .icon {
          color: #fff;
          position: relative;
          top: -2px;
          left: -25px;
          width: 20px;
          height: 20px;
          transition: 2.5s;
          -o-transform: rotate(720deg);
          -ms-transform: rotate(720deg);
          -moz-transform: rotate(720deg);
          -webkit-transform: rotate(720deg);
          transform: rotate(720deg);
        }
        span {
          right: 9px;
        }
      }
      .active {
        display: block;
      }
      .notActive {
        display: none;
      }

      span {
        position: relative;
      }
    }
  }

  #FormElement {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 18px;
    @media (min-width: 992px) {
      display: none;
    }

    #Rounds {
      margin-bottom: 7px;
    }

    #Rounds .buttonOfRound1 {
      background-color: #63b2e6;
      height: 34px;
      width: 210px;
      border: 0;
      border-radius: 3px 0 0 3px;
      color: #f4f4f4;
      text-align: center;
      font-size: 14px;
      font-weight: 700;

      @media (max-width: 660px) {
        width: 33vw;
      }
    }

    #Rounds .buttonOfRound2 {
      background-color: #32404e;
      height: 34px;
      width: 210px;
      border: 0;
      border-radius: 0 3px 3px 0;
      color: #6b8299;
      text-align: center;
      font-size: 14px;
      font-weight: 700;

      @media (max-width: 660px) {
        width: 33vw;
      }
    }
  }
`;

export const TableMain = styled.div`
  .containerHeader {
    max-width: 1300px;
    width: 100%;
    display: flex;
    justify-content: center;

    @media (max-width: 1600px) {
      flex-flow: wrap;
      align-items: center;
      justify-content: center;
    }
  }

  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  margin-bottom: 25px;

  .bold {
    font-weight: 700;
  }

  .green {
    color: #62c744;
  }

  .gray {
    color: #6b8299;
  }
  table {
    width: 260px;
    height: fit-content;
    border-radius: 7px;
    background-color: #32404e;
    margin-right: 30px;

    @media (max-width: 660px) {
      width: 66vw;
      margin-right: 0;
    }

    td,
    th {
      border-top: 0;
      border-bottom: 0;
      text-align: center;
      width: 100px;
    }

    thead {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5px;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #6b8299;
        border-radius: 5px;
        height: 35px;
      }
    }
    tbody {
      display: flex;
      flex-direction: column;
      align-items: center;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 20px;
        height: 35px;

        div {
          display: flex;
          justify-content: center;
          p {
            padding-right: 3px;
            margin-bottom: 0;
          }
        }
        &:nth-child(2n) {
          background-color: #263340;
        }
        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
`;

export const Footer = styled.footer`
  .container {
    display: flex;
    justify-content: space-around;
  }
  background: #222f3b;
  min-height: 200px;
  width: 100vw;

  display: flex;
  justify-content: space-around;
  margin-top: 25px;
  padding: 25px;
  overflow: auto;

  @media (max-width: 570px) {
    justify-content: start;
    padding: 0px;
  }

  .bold {
    font-weight: 700;
  }

  .green {
    span {
      color: #62c744;
      font-weight: 700;
    }
  }

  .gray {
    span {
      color: #6b8299;
      font-weight: 700;
    }
  }
  table {
    width: 540px;
    border-radius: 7px;
    background-color: #32404e;
    margin: 10px;

    @media (max-width: 570px) {
      margin: 0px;
    }

    p {
      margin-bottom: 0;
    }

    td,
    th {
      border-top: 0;
      border-bottom: 0;
      width: 200px;
      text-align: center;
    }
    td {
      &:nth-child(2n),
      &:nth-child(3n) {
        text-align: left;
      }
    }

    thead {
      display: flex;
      align-items: center;
      justify-content: center;
      padding-top: 5px;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        background-color: #6b8299;
        border-radius: 5px;
        height: 35px;
      }
    }
    tbody {
      display: flex;
      flex-direction: column;
      align-items: center;
      tr {
        width: 95%;
        display: flex;
        align-items: center;
        justify-content: space-around;
        border-radius: 20px;
        height: 35px;

        div {
          display: flex;
          p {
            padding-right: 3px;
            margin-bottom: 0;
          }
        }
        &:nth-child(2n) {
          background-color: #263340;
        }
        &:last-child {
          margin-bottom: 8px;
        }
      }
    }
  }
`;
